import { Component, OnInit } from '@angular/core';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { VendorService } from 'src/app/services/vendor.service';
import { ExpenseService } from 'src/app/services/expense.service';
import { VendorResponse } from 'src/app/models/vendor.model';
import { CompanyService } from 'src/app/services/company.service';

declare let $: any;

@Component({
  selector: 'app-expense-submit',
  templateUrl: './expense-submit.component.html',
  styleUrls: ['./expense-submit.component.scss']
})
export class ExpenseSubmitComponent {
  document = {
    date: '',
    month: '',
    typeId: null,
    expenseType: 'Producto',
    series: '',
    number: '',
    total: 0,
    declaredTotal: 0,
    description: ''
  };

  documents: any[] = [];
  totalRegistered = 0;

  inputs = {
    currency: 'Quetzales (Q)',
    warehouse: {
			value: null,
			verified: false,
			required: true,
			message: 'Campo requerido',
			class: 'fa-asterisk',
			color: 'danger',
			tooltip: 'status-warehouse',
			data: {
				id: null
			}
		}
  };
  currency = ['Quetzales (Q)', 'Dolares ($)'];
  warehouses = [];
  clients = [];
  categories = [];
  filterWarehouses = [];
  filterClients = [];
  filterCategories = [];
  timeout = null;
  allWarehouses: WarehouseResponse[] = [];
  filterWarehouse: InputAutocompleteModel = new InputAutocompleteModel("", false, true, "", "", "", "", null, []);
  client = new InputAutocompleteModel("", false, true, "", "loading", "", "", null, []);
  category = new InputAutocompleteModel("", false, true, "", "loading", "", "", null, []);
  allowedWarehouses: { [key: number]: boolean } = {};
  user: number = null;
  clientSelected = null;
  categorySelected = null;
  documentTypes = [];
  warehouseSelected = null;

  editDocument = false;
  idEditDocument = null;
  useBatch = false;
  batchName = '';
  exchangeRate = 1;

  isAddCategory = false;
  allCategories = [];
  allCategory = new InputAutocompleteModel("", false, true, "", "loading", "", "", null, []);
  allCategorySelected = null;

  newVendor: VendorResponse = new VendorResponse();
  creating = false;
  editing = false;
  checkAdministration = false;
  loadingConfig = false;

  

  updateTotals() {
    this.totalRegistered = this.documents.reduce((sum, doc) => sum + Number(doc.total), 0);
  }

  onCurrencyChange() {
    if (this.inputs.currency === 'Quetzales (Q)') {
      this.exchangeRate = 1;
    }
  }

  constructor(
    private warehouseService: WarehouseService,
    private authService: AuthenticationService,
    private toastService: ToastrService,
    private vendorService: VendorService,
    private expenseService: ExpenseService,
    private companyService: CompanyService,
  ) {
    var getUserPosition = authService.getUserPosition();
    if (getUserPosition) {
      getUserPosition.forEach((u) => {
        if (u.warehouse != 0) {
          this.allowedWarehouses[u.warehouse] = true;
        }
      });
    }
    this.user = JSON.parse(authService.getCurrentUser()).id;
  }

  getCheckAdministration(){
    this.companyService.checkCompanyConfigAdministration().subscribe({
      next: (response: ResponseObject) => {
        this.checkAdministration = response.data;
        this.loadingConfig = true;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.loadingConfig = true;
      }
    })
  }

  ngOnInit(): void {
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data;
        this.clients = clientsData;
        this.client.filterElements = clientsData;
        this.client.class = "fa-list";
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    });
    this.expenseService.getDocumentTypes().subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data;
        this.documentTypes = clientsData;
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    });
    this.getWarehousesByFilter();
    this.getCheckAdministration();
  }


  selectWarehouse(warehouse: WarehouseResponse) {
    this.filterWarehouse.value = warehouse.name;
    this.filterWarehouse.verified = true;
    this.filterWarehouse.data = warehouse;
    this.filterWarehouse.class = "fa-circle-check";
    this.warehouseSelected = warehouse;
    this.getDocumentsTempByLocation(warehouse.id);
  }

  searchWarehouse() {
    clearTimeout(this.timeout);
    this.filterWarehouse.class = "typing";
    this.timeout = setTimeout(() => {
      this.getWarehousesByFilter();
    }, 300);
  }

  getWarehousesByFilter() {
    this.filterWarehouse.class = "loading";
    this.warehouseService.getWarehouseByClue(this.filterWarehouse.value).subscribe({
      next: (response: ResponseObject) => {
        this.allWarehouses = response.data as WarehouseResponse[];
        this.warehouses = this.allWarehouses.filter((warehouse) => {
          return this.allowedWarehouses[warehouse.id]
        })
        if (this.warehouses.length == 0) {
          this.warehouses = this.allWarehouses;
        }
        this.filterWarehouse.class = "fa-list";
        // this.selectWarehouse(this.warehouses[0]);
      },
      error: (error: HttpErrorResponse) => {
        this.filterWarehouse.class = "fa-xmark";
        this.toastService.error(error.error.message);
      }
    })
  }

  writeClient() {
    clearTimeout(this.timeout);
    this.client.class = "typing";
    this.timeout = setTimeout(() => {
      this.client.class = "loading";
      this.vendorService.getProvidesByClue(this.client.value).subscribe({
        next: (response: ResponseObject) => {
          this.client.filterElements = response.data;
          if (this.client.filterElements.length == 0) {
            this.client.class = "fa-xmark";
            this.client.required = true;
          } else {
            this.client.class = "fa-filter";
          }
        }, error: (error: any) => {
          this.client.required = true;
          this.client.class = "fa-xmark";
          this.toastService.error("Error al obtener los datos del cliente " + this.client.value);
        }
      })
    }, 500);
  }

  writeCategory() {
    clearTimeout(this.timeout);
    this.category.class = "typing";
    this.timeout = setTimeout(() => {
      const searchTerm = this.category.value.toLowerCase().trim();
  
      if (!searchTerm) {
        this.category.filterElements = [...this.categories]; // Restauramos todas
        this.category.class = this.categories.length ? "fa-filter" : "fa-xmark";
        return;
      }
  
      const filtered = this.categories.filter(cat => 
        cat.name.toLowerCase().includes(searchTerm)
      );
  
      this.category.filterElements = filtered;
      this.category.class = filtered.length ? "fa-filter" : "fa-xmark";
    }, 300);
  }

  writeAllCategory() {
    clearTimeout(this.timeout);
    this.allCategory.class = "typing";
    this.timeout = setTimeout(() => {
      const searchTerm = this.allCategory.value.toLowerCase().trim();
  
      if (!searchTerm) {
        this.allCategory.filterElements = [...this.allCategories]; // Restauramos todas
        this.allCategory.class = this.allCategories.length ? "fa-filter" : "fa-xmark";
        return;
      }
  
      const filtered = this.allCategories.filter(cat => 
        cat.name.toLowerCase().includes(searchTerm)
      );
  
      this.allCategory.filterElements = filtered;
      this.allCategory.class = filtered.length ? "fa-filter" : "fa-xmark";
    }, 300);
  }
  

  selectClient(client: any, status) {
    this.client.value = "";
    this.client.class = "";
    this.client.required = false;
    this.filterClients = this.clients;
    console.log(client);
    this.clientSelected = client;
    this.getCategories(client.id);
    $('body').click();
  }

  getCategories(idVendor) {
    this.vendorService.getCategoriesVendor(idVendor).subscribe({
      next: (response: ResponseObject) => {
        this.categories = response.data;
        this.category.filterElements = this.categories;
        this.category.class = "fa-list";
        console.log("cate")
        console.log(this.categories)
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las categorias del proveedor");
      }
    });
  }

  selectCategory(category: any, status) {
    this.category.value = category.name;
    this.category.class = "fa-circle-check";
    this.category.verified = true;
    this.category.data = category;
    this.category.required = false;
    this.categorySelected = category;
    $('body').click();
  }

  selectAllCategory(category: any, status) {
    this.allCategory.value = category.name;
    this.allCategory.class = "fa-circle-check";
    this.allCategory.verified = true;
    this.allCategory.data = category;
    this.allCategory.required = false;
    this.allCategorySelected = category;
    $('body').click();
  }

  addDocument() {
    this.sendTempExpense();
    this.clearDocumentForm();
  }

  sendTempExpense() {
    const request:any = {
      service: this.document.expenseType === 'Servicio' ? "true" : "false",
      docDate: new Date(this.document.date).toISOString(),
      inputDate: new Date(this.document.month + '-01T06:00:00.000Z').toISOString(),
      sDoc: this.document.series,
      noDoc: this.document.number,
      tdoc: this.document.total,
      tdec: this.document.declaredTotal,
      desc: this.document.description,
      vendor: this.clientSelected?.id || null,
      category: this.categorySelected?.id || null,
      vendorName: this.clientSelected?.name || '',
      categoryName: this.categorySelected?.name || '',
      expType: 1, // Si es siempre fijo, así se queda
      type: this.document.typeId,
      currency: this.inputs.currency === 'Quetzales (Q)' ? '0' : '1'
    };
  
    const locationId = this.warehouseSelected.id

    if (this.editDocument) {
      request.id = this.idEditDocument;
      request.user = this.authService.getUser().id;
      request.company = this.authService.getCurrentCompanyId();
      request.creationDate = Date.now();
      request.location = locationId;
      request.currency = this.inputs.currency === 'Quetzales (Q)' ? 0 : 1
    }

    console.log(request);

    if(this.editDocument){
      this.expenseService.updateTempExpense(this.idEditDocument, request).subscribe({
        next: (response: any) => {
          this.editDocument = false;
          this.idEditDocument = null;
          this.toastService.success('Documento editado exitosamente');
          this.getDocumentsTempByLocation(locationId);
        },
        error: (error) => {
          this.toastService.error('Error al editar el documento');
          console.error(error);
        }
      });
    }else{
      this.expenseService.setTempExpense(locationId, request).subscribe({
        next: (response) => {
          this.toastService.success('Documento guardado exitosamente');
          this.getDocumentsTempByLocation(locationId);
        },
        error: (error) => {
          this.toastService.error('Error al guardar el documento');
          console.error(error);
        }
      });
    }
  
    
  }

  clearDocumentForm() {
    this.document = {
      date: '',
      month: '',
      typeId: null,
      expenseType: 'Producto',
      series: '',
      number: '',
      total: 0,
      declaredTotal: 0,
      description: ''
    };
  }

  getDocumentsTempByLocation(warehouseId) {
    this.expenseService.getTempExpenses(warehouseId).subscribe({
      next: (response: any) => {
        console.log("Devueltos los expenses de: " + warehouseId);
        console.log(response.data);
  
        this.documents = response.data.map(doc => ({
          date: new Date(doc.docDate).toLocaleDateString(),
          type: this.getDocumentTypeName(doc.type),
          series: doc.sDoc,
          number: doc.noDoc,
          total: doc.tdoc,
          original: doc
        }));
  
        this.updateTotals();
      },
      error: (error) => {
        this.toastService.error('Error al cargar los documentos');
        console.error(error);
      }
    });
  }

  getDocumentTypeName(tdoc: number): string {
    const type = this.documentTypes.find(d => d.id === tdoc);
    return type ? type.name : 'Desconocido';
  }

  removeDocument(doc: any) {
    this.deleteExpenseTempDoc(doc.original.id);
    const locationId = this.warehouseSelected.id
    this.getDocumentsTempByLocation(locationId);
    this.updateTotals();
  }

  deleteExpenseTempDoc(docId) {
    this.expenseService.deleteTempExpense(docId).subscribe({
      next: (response: any) => {
        this.toastService.success('Eliminado de la lista correctamente');
        this.selectWarehouse(this.warehouseSelected);
      },
      error: (error) => {
        this.toastService.error('Error al eliminar el documento');
        console.error(error);
      }
    });
  }

  editDoc(editDoc: any) {
    this.editDocument = true;
    this.idEditDocument = editDoc.original.id;
  
    const original = editDoc.original;
  
    const selectedClient = this.clients.find(client => client.id === original.vendor);
    if (selectedClient) {
      this.clientSelected = selectedClient;
      this.client.value = selectedClient.name;
      this.client.class = "fa-circle-check";
      this.client.verified = true;
      this.client.required = false;

      this.vendorService.getCategoriesVendor(selectedClient.id).subscribe({
        next: (response: ResponseObject) => {
          this.categories = response.data;
          this.category.filterElements = this.categories;
          this.category.class = "fa-list";
  
          const selectedCategory = this.categories.find(cat => cat.id === original.category);
          if (selectedCategory) {
            this.categorySelected = selectedCategory;
            this.category.value = selectedCategory.name;
            this.category.class = "fa-circle-check";
            this.category.verified = true;
            this.category.required = false;
          }
  
          
          const docDate = new Date(original.docDate);
          const inputDate = new Date(original.inputDate);
          
          this.document = {
            date: docDate.toLocaleDateString('en-CA'), // yyyy-MM-dd
            month: inputDate.getFullYear() + '-' + String(inputDate.getMonth() + 1).padStart(2, '0'), // yyyy-MM
            typeId: original.type,
            expenseType: original.service ? 'Servicio' : 'Producto',
            series: original.sDoc,
            number: original.noDoc,
            total: original.tdoc,
            declaredTotal: original.tdec,
            description: original.desc
          };

          console.log(document)

          this.inputs.currency = original.currency === 0 ? 'Quetzales (Q)' : 'Dolares ($)';

  
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las categorías del proveedor");
        }
      });
  
    } else {
      this.editDocument = false;
      this.idEditDocument = null;
      this.toastService.error("Proveedor no encontrado en la lista de clientes");
    }
  }

  updateDoc() {
    this.sendTempExpense();
    this.clearDocumentForm();
  }

  registerDocuments() {
    if (this.useBatch) {
      if (!this.batchName.trim()) {
        this.toastService.warning('Debes ingresar un nombre para el lote');
        return;
      }
      this.registerBatch();
    } else {
      this.registerAlone();
    }
  }

  registerBatch() {
    if(this.documents.length >= 2){
      const request = {
        lotName: this.batchName,
        references: [],
        currency: this.inputs.currency === 'Quetzales (Q)' ? '0' : '1',
        exchangeRate: this.exchangeRate
      };
    
      const currency = this.inputs.currency === 'Quetzales (Q)' ? 0 : 1;
  
  
      this.expenseService.makeLotTempExpenses(currency,request).subscribe({
        next: (response: any) => {
          this.toastService.success('Gastos agregados: ' + this.documents.length);
          this.selectWarehouse(this.warehouseSelected);
        },
        error: (error) => {
          this.toastService.error('Error al cargar los gastos');
          console.error(error);
        }
      });
    }else{
      this.toastService.error("Necesita mas de un gasto para ingresar como lote");
    }
  }

  registerDocumentsAdministrative(){
    if (this.useBatch) {
      if (!this.batchName.trim()) {
        this.toastService.warning('Debes ingresar un nombre para el lote');
        return;
      }
      this.registerBatch();
    } else {
      this.registerAloneAdministrative();
    }
  }

  registerAloneAdministrative(){
    const request = {
      references: [],
      currency: this.inputs.currency === 'Quetzales (Q)' ? '0' : '1',
      exchangeRate: 1
    };
  
    const locationId = this.warehouseSelected.id


    this.expenseService.makeTempExpensesAdministrative(locationId,request).subscribe({
      next: (response: any) => {
        this.toastService.success('Gastos agregados: ' + this.documents.length);
        this.selectWarehouse(this.warehouseSelected);
      },
      error: (error) => {
        this.toastService.error('Error al cargar los gastos');
        console.error(error);
      }
    });
  }

  registerAlone() {
    const request = {
      references: [],
      currency: this.inputs.currency === 'Quetzales (Q)' ? '0' : '1',
      exchangeRate: 1
    };
  
    const locationId = this.warehouseSelected.id


    this.expenseService.makeTempExpenses(locationId,request).subscribe({
      next: (response: any) => {
        this.toastService.success('Gastos agregados: ' + this.documents.length);
        this.selectWarehouse(this.warehouseSelected);
      },
      error: (error) => {
        this.toastService.error('Error al cargar los gastos');
        console.error(error);
      }
    });
  }

  addCategory(){
    console.log("Add category");
    this.isAddCategory = true;
    this.getAllCategories();
  }

  resetDeletingDiv() {
    this.isAddCategory = false;
  }

  getAllCategories(){
    this.vendorService.getAllCategoriesVendor().subscribe({
      next: (response: ResponseObject) => {
        this.allCategories = response.data;
        this.allCategory.filterElements = this.allCategories;
        this.allCategory.class = "fa-list";
        console.log(this.allCategories)
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las categorias del proveedor");
      }
    });
  }

  addCategoryToVendor() {
    const typedValue = this.allCategory.value.trim().toLowerCase();
  
    // Buscar coincidencia exacta con alguna categoria que ya existe en el listado
    const existingCategory = this.allCategories.find(cat =>
      cat.name.toLowerCase() === typedValue
    );
  
    if (!typedValue) {
      this.toastService.warning('Debe ingresar el nombre de una categoría');
      return;
    }
  
    if (!this.clientSelected) {
      this.toastService.error("Debe asignar un proveedor para agregar una categoría");
      return;
    }
  
    if (existingCategory) {
      // Ya existe: asociarla directamente
      this.updateCategoryVendor(existingCategory.id);
    } else {
      // No existe: crearla y luego asociarla
      this.createCategoryVendor(this.allCategory.value.trim());
      
    }
  }

  updateCategoryVendor(idCategory){
    this.vendorService.editCategoryVendorExpense(this.clientSelected.id, idCategory).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Categoría agregada correctamente");
        this.isAddCategory = false;
        this.getCategories(this.clientSelected.id);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al agregar la categoría al proveedor");
      }
    });
  }

  createCategoryVendor(newCategory){
    this.vendorService.createCategoryVendor(newCategory).subscribe({
      next: (response: ResponseObject) => {
        const createdCategory = response.data;
        this.updateCategoryVendor(createdCategory.id);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la nueva categoría");
      }
    });
  }

  resetNewFamily() {
      this.newVendor = new VendorResponse();
    }

  editAndSave(vendor: any, isCreating: boolean) {
      if (!isCreating) {
        this.vendorService.getCategoriesVendor(vendor.id).subscribe({
          next: (response: ResponseObject) => {
            this.newVendor = vendor;
            this.newVendor['categories'] = response.data;
            this.newVendor.provIn = this.newVendor.inventarios;
            this.creating = false;
            this.editing = true;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("Error al obtener las categorias del proveedor");
          }
        })
      } else {
        this.newVendor = new VendorResponse();
        this.creating = true;
        this.editing = false;
      }
  
    }

    closeModalProvider() {
      this.creating = false;
      this.editing = false;
      
      this.vendorService.getVendors().subscribe({
        next: (response: ResponseObject) => {
          const clientsData = response.data;
          this.clients = clientsData;
          this.client.filterElements = clientsData;
          this.client.class = "fa-list";
        },
        error: (error) => {
          console.error("Error al comunicarse con el servidor", error);
        }
      });
      this.expenseService.getDocumentTypes().subscribe({
        next: (response: ResponseObject) => {
          const clientsData = response.data;
          this.documentTypes = clientsData;
        },
        error: (error) => {
          console.error("Error al comunicarse con el servidor", error);
        }
      });
      this.getWarehousesByFilter();
    }
  

}
